import { Component, createSignal } from 'solid-js'
import FormModal from '/web/shared/FormModal'
import { userStore } from '/web/store'
import { formStore } from '/web/store/form'

const CreatorFormModal: Component = () => {
  const state = userStore()
  const [loading, setLoading] = createSignal(false)

  const handleSubmit = async (e: Event) => {
    e.preventDefault()
    const form = e.target as HTMLFormElement
    const data = {
      email: form.email.value,
      twitterHandle: form.twitter.value,
      instagramHandle: form.instagram.value,
    }

    setLoading(true)
    const success = await formStore.submitCreatorForm(data)
    setLoading(false)

    if (success) {
      userStore.creatorModal(false)
    }
  }

  return (
    <FormModal
      title="Become a Creator"
      isOpen={state.showCreator}
      onClose={() => userStore.creatorModal(false)}
      onSubmit={handleSubmit}
    >
      <div class="flex flex-col gap-6">
        <div class="mb-1 text-[16px]">
          Interested in becoming a CosplayFans creator? Submit your information below and we’ll be
          in contact.
        </div>
        <div class="flex flex-col">
          <label class="mb-2 block font-clash text-[15px] text-white">
            Email Address <span class="text-xs font-normal text-cosplay-blue-100">(Required)</span>
          </label>
          <input
            name="email"
            type="email"
            required
            placeholder="Enter your email"
            class="rounded-xl border border-white bg-white/10 p-4 text-sm"
          />
        </div>
        <div class="flex flex-col">
          <label class="mb-2 block font-clash text-[15px] text-white">
            Twitter Handle <span class="text-xs font-normal text-cosplay-blue-100">(Required)</span>
          </label>
          <input
            name="twitter"
            placeholder="@username"
            class="rounded-xl border border-white bg-white/10 p-4 text-sm"
          />
        </div>
        <div class="flex flex-col">
          <label class="mb-2 block font-clash text-[15px] text-white">
            Instagram Handle{' '}
            <span class="text-xs font-normal text-cosplay-blue-100">(Required)</span>
          </label>
          <input
            name="instagram"
            placeholder="@username"
            class="rounded-xl border border-white bg-white/10 p-4 text-sm"
          />
        </div>
        <button
          class="mb-6 mt-3 rounded-lg border-[0.5px] border-white bg-gradient-to-r from-cosplay-blue-200 to-cosplay-purple px-4 py-2 text-[22px] font-bold"
          type="submit"
          disabled={loading()}
        >
          {loading() ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </FormModal>
  )
}

export default CreatorFormModal
